import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Placeholder from '../../../components/Placeholder';
import { reducer, state } from '../../../redux/sagas/aws-cognito-redux-saga';

import {
  Anchor,
  Button,
  ButtonPlaceholder,
  Input,
  InputWrapper,
  InputRow,
  InputError,
  PageContent,
  Subtitle,
  SubtitlePlaceholder,
  Text,
  Title,
  Wrapper,
  Spinner,
  VerifyerAccountText,
} from './ChangePasswordPage.style';
import ChangePasswordSuccess from './ChangePasswordSuccess';
import { TABLET_P } from '../../../constants';

class ChangePasswordPage extends Component {
  state = {
    email: '',
    code: '',
    password: '',
    passwordMatch: '',
    loading: false,
    error: '',
    emailError: '',
    codeError: '',
    passwordError: '',
    passwordMatchError: '',
    isValidForm: false,
  };

  componentWillMount() {
    this.props.init();
  }

  componentWillReceiveProps(nextProps) {
    const { auth } = nextProps;
    const { locale, history } = this.props;
    if (this.props.auth.hasChangedPassword === state.AUTH_UNKNOWN && auth.hasChangedPassword === state.AUTH_SUCCESS) {
      this.setState({
        loading: false,
        error: '',
      });
    } else if (auth.error) {
      this.setState({
        loading: false,
        error: nextProps.auth.error.message,
      });
    }
  }

  handleChangePassword = e => {
    e.preventDefault();
    const { changePassword } = this.props;
    const { email, code, password } = this.state;
    this.setState(
      {
        loading: true,
        error: false,
      },
      () => {
        changePassword(email.toLowerCase(), code, password);
      }
    );
  };

  handleSignIn = () => {
    const { history, locale } = this.props;
    history.push(`/${locale}/salon-consultation/login`);
  };

  handleInputChange = type => e =>
    this.setState(
      {
        [type]: e.target.value,
        error: false,
      },
      () => {
        this.isValidForm(type);
      }
    );

  isValidForm = type => {
    const { email, code, password, passwordMatch } = this.state;
    let { emailError, codeError, passwordError, passwordMatchError, isValidForm } = this.state;
    const { copy } = this.props;
    switch (type) {
      case 'email':
        if (email.length > 0) {
          emailError = '';
        } else {
          emailError =
            (copy.errorMessage && copy.errorMessage.notEnteredEmail && copy.errorMessage.notEnteredEmail) || 'Error';
        }
        break;
      case 'code':
        if (code.length > 0) {
          codeError = '';
        } else {
          codeError =
            (copy.errorMessage && copy.errorMessage.notEnteredCode && copy.errorMessage.notEnteredCode) || 'Error';
        }
        break;
      case 'password':
        if (password.length > 0) {
          if (passwordMatch === password) {
            passwordError = '';
          } else {
            passwordError =
              (copy.errorMessage && copy.errorMessage.unmatchPassword && copy.errorMessage.unmatchPassword) || 'Error';
          }
        } else {
          passwordError =
            (copy.errorMessage && copy.errorMessage.notEnteredPassword && copy.errorMessage.notEnteredPassword) ||
            'Error';
        }
        if (passwordMatch.length > 0) {
          passwordMatchError = '';
        }
        break;
      case 'passwordMatch':
        if (passwordMatch.length > 0) {
          if (passwordMatch === password) {
            passwordMatchError = '';
          } else {
            passwordMatchError =
              (copy.errorMessage && copy.errorMessage.unmatchPassword && copy.errorMessage.unmatchPassword) || 'Error';
          }
        } else {
          passwordMatchError =
            (copy.errorMessage &&
              copy.errorMessage.notEnteredPasswordConfirm &&
              copy.errorMessage.notEnteredPasswordConfirm) ||
            'Error';
        }
        if (passwordMatch.length > 0) {
          passwordError = '';
        }
        break;

      default:
        break;
    }
    isValidForm =
      email.length > 0 &&
      code.length >= 6 &&
      password.length >= 6 &&
      passwordMatch === password &&
      (emailError === '' && codeError === '' && passwordError === '' && passwordMatchError === '');

    this.setState({ emailError, codeError, passwordError, passwordMatchError, isValidForm });
  };

  render() {
    const { locale, copy, auth } = this.props;
    const {
      email,
      code,
      password,
      passwordMatch,
      loading,
      error,
      emailError,
      codeError,
      passwordError,
      passwordMatchError,
      isValidForm,
    } = this.state;
    const copyf = (copy.forgotPassword && copy.forgotPassword) || {};

    return auth.hasChangedPassword === state.AUTH_UNKNOWN ? (
      <Wrapper>
        <PageContent>
          {Object.keys(copyf).length !== 0 && copyf.constructor === Object ? (
            <Title>{copyf.forgotYourPassword}</Title>
          ) : (
            <Placeholder h="40px" w={window.innerWidth > TABLET_P ? '500px' : '100%'} />
          )}
          {Object.keys(copyf).length !== 0 && copyf.constructor === Object ? (
            <Subtitle>{copyf.emailYouInstructions}</Subtitle>
          ) : (
            <SubtitlePlaceholder>
              <Placeholder h="24px" w={window.innerWidth > TABLET_P ? '400px' : '100%'} />
            </SubtitlePlaceholder>
          )}
          <form onSubmit={this.handleChangePassword}>
            <InputWrapper>
              <InputRow>
                <Input
                  type="email"
                  placeholder={copyf.emailPlaceholder}
                  value={email}
                  onChange={this.handleInputChange('email')}
                  required
                />
                <InputError>{emailError}</InputError>
              </InputRow>
              <InputRow>
                <Input
                  type="text"
                  placeholder={copyf.codePlaceholder}
                  value={code}
                  onChange={this.handleInputChange('code')}
                  required
                />
                <InputError>{codeError}</InputError>
              </InputRow>
              <InputRow>
                <Input
                  type="password"
                  placeholder={copyf.passwordPlaceholder}
                  value={password}
                  onChange={this.handleInputChange('password')}
                  required
                />
                <InputError>{passwordError}</InputError>
              </InputRow>
              <InputRow>
                <Input
                  type="password"
                  placeholder={copyf.passwordMatchPlaceholder}
                  value={passwordMatch}
                  onChange={this.handleInputChange('passwordMatch')}
                  required
                />
                <InputError>{passwordMatchError}</InputError>
              </InputRow>
            </InputWrapper>
            {error && <p style={{ color: 'red', fontSize: '12px' }}>{error}</p>}
            {Object.keys(copyf).length !== 0 && copyf.constructor === Object ? (
              <Button type="submit" disabled={!isValidForm || loading}>
                {loading ? <Spinner /> : copyf.changePassword}
              </Button>
            ) : (
              <ButtonPlaceholder>
                <Placeholder h="65px" w={window.innerWidth > TABLET_P ? '300px' : '100%'} />
              </ButtonPlaceholder>
            )}
          </form>
          {Object.keys(copyf).length !== 0 && copyf.constructor === Object ? (
            <Text>
              <VerifyerAccountText>{copyf.alreadyHaveAccount}</VerifyerAccountText>
              <Link to={`/${locale}/salon-consultation/login`} href={`/${locale}/salon-consultation/login`}>
                <Anchor>{copyf.signIn}</Anchor>
              </Link>
            </Text>
          ) : (
            <Placeholder h="86px" w={window.innerWidth > TABLET_P ? '250px' : '100%'} />
          )}
        </PageContent>
      </Wrapper>
    ) : (
      <ChangePasswordSuccess copy={copy} locale={locale} />
    );
  }
}

ChangePasswordPage.defaultProps = {
  copy: {},
};

ChangePasswordPage.propTypes = {
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  auth: PropTypes.shape({
    hasSentCode: PropTypes.string,
    isSignedIn: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  changePassword: PropTypes.func.isRequired,
  init: PropTypes.func.isRequired,
};

const mapState = state => ({
  copy: state.salonConsultaionSiteOptions.siteCopy,
  locale: state.locale,
  auth: state.auth,
});

const mapDispatch = dispatch => ({
  changePassword: (username, code, password) => dispatch(reducer.changePassword(username, code, password)),
  init: () => dispatch(reducer.init()),
});

export default connect(mapState, mapDispatch)(ChangePasswordPage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/ChangePasswordPage/ChangePasswordPage.js